import { render, staticRenderFns } from "./OtherPrescription.vue?vue&type=template&id=2fa03a0a&scoped=true&"
import script from "./OtherPrescription.vue?vue&type=script&lang=js&"
export * from "./OtherPrescription.vue?vue&type=script&lang=js&"
import style0 from "./OtherPrescription.vue?vue&type=style&index=0&id=2fa03a0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa03a0a",
  null
  
)

export default component.exports